import { GetEventDetailsResponse } from '@nirvana/shared/dtos/types/raw-events/gz-console';
import { ColumnDetails } from '@nirvana/shared/dtos/types/alerts/common';
import { SectionAction, SectionContent } from '../../ui/gzGenericDetailsSection/types';
import { TaskTarget } from '@nirvana/shared/navigation';

export interface GetEventDetailsResponseFrontend extends GetEventDetailsResponse {
  allColumnsDetails: Array<ColumnDetails>;
  isPartner: boolean;
  permissions: ActionsPermissions;
  taskTarget?: TaskTarget;
}

export enum ActionPermissionState {
  ACTIVE,
  MISSING_NETWORK,
  MISSING_ISOLATE,
  MISSING_BLOCKLIST,
  WRONG_ENDPOINT_TYPE,
  ISOLATED,
  REMOVED,
  NO_HASH,
  NO_POLICY,
  OTHER,
  LOST_ACCESS,
  MISSING_POLICIES_READ,
  MISSING_POLICIES_WRITE,
  MISSING_FEATURE,
}

export interface ExclusionRecord {
  companyId: string;
  type: number;
  specifics: ExclusionRecordSpecifics;
}

interface ExclusionRecordSpecifics {
  type: number;
  path: string;
  modules: Array<number>;
}

export interface ActionsPermissions {
  scan: ActionPermissionState;
  isolate: ActionPermissionState;
  network: ActionPermissionState;
  alerts: ActionPermissionState;
  exclusion: ActionPermissionState;
  blocklist: ActionPermissionState;
  endpointDetails: ActionPermissionState;
  policy: ActionPermissionState;
  riskScore: ActionPermissionState;
}

export interface SpecificsThreatData {
  title: string;
  sectionContent: Array<SectionContent>;
  sectionActions?: Array<SectionAction>;
}

export enum DetailsPanelEvents {
  SHOW_ALERTS = 'showAlerts',
  CREATE_EXCLUSIONS = 'createExclusions',
  SECURITY_RISKS_DRILL_DOWN = 'securityRisksDrillDown',
  POLICY_DRILL_DOWN = 'policyDrillDown',
  NAVIGATE_TO_DETAILS_PANEL = 'navigateToDetailsPanel',
  ADD_TO_BLOCK_LIST = 'addToBlockList',
  NAVIGATE_TO_NETWORK = 'navigateToNetwork',
}

export interface SecurityRisksDrillDown {
  company: {
    id: string;
    name: string;
  };
  endpoint: {
    id?: string;
    name?: string;
  };
  section?: string;
}
